(function () {
  var DURATION_SEC = 2;
  /* Alinhado ao painel lateral do cart-drawer (min-width: 1200px). */
  var LATERAL_PANEL_QUERY = "(min-width: 1200px)";
  var DISMISSED_CLASS = "cart-drawer-lateral-dismissed";
  var active = null;

  function clearActive() {
    if (!active) return;
    clearInterval(active.intervalId);
    if (active.drawer && active.onHide) {
      active.drawer.removeEventListener("dialog:after-hide", active.onHide);
    }
    active = null;
  }

  function findRoot() {
    var roots = document.querySelectorAll("[data-variant-added-auto-close]");
    for (var i = 0; i < roots.length; i++) {
      var drawer = roots[i].closest("cart-notification-drawer, quick-buy-drawer");
      if (drawer && drawer.open) {
        return { root: roots[i], drawer: drawer };
      }
    }
    var first = document.querySelector("[data-variant-added-auto-close]");
    if (first) {
      var d = first.closest("cart-notification-drawer, quick-buy-drawer");
      if (d) return { root: first, drawer: d };
    }
    return null;
  }

  function start() {
    clearActive();

    var found = findRoot();
    if (!found) return;

    var root = found.root;
    var drawer = found.drawer;

    // Painel lateral (desktop): sem "fechou o carrinho", mantém o fluxo antigo (fecha notificação na hora).
    if (
      window.matchMedia &&
      window.matchMedia(LATERAL_PANEL_QUERY).matches &&
      !document.documentElement.classList.contains(DISMISSED_CLASS)
    ) {
      if (typeof drawer.hide === "function") {
        drawer.hide();
      } else {
        drawer.removeAttribute("open");
      }
      return;
    }

    var numEl = root.querySelector("[data-variant-added-countdown]");
    var unitEl = root.querySelector("[data-variant-added-countdown-unit]");
    if (!numEl) return;

    var remaining = DURATION_SEC;

    function updateText() {
      numEl.textContent = String(remaining);
      if (unitEl) {
        unitEl.textContent = remaining === 1 ? "segundo" : "segundos";
      }
    }

    updateText();

    function onHide() {
      clearActive();
    }

    drawer.addEventListener("dialog:after-hide", onHide);

    active = {
      drawer: drawer,
      onHide: onHide,
      intervalId: setInterval(function () {
        remaining -= 1;
        if (remaining <= 0) {
          clearActive();
          if (typeof drawer.hide === "function") {
            drawer.hide();
          }
          return;
        }
        updateText();
      }, 1000),
    };
  }

  document.addEventListener("variant:add", function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(start);
    });
  });
})();
